import { useState, useEffect } from "react";
import { Star } from "lucide-react";

export default function Reviews() {
  const [form, setForm] = useState({ name: "", rating: 0, comment: "" });
  const [hovered, setHovered] = useState(0);
  const [status, setStatus] = useState("idle");

  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.rating === 0) return;
    setStatus("loading");

    try {
      const res = await fetch("/api/submit-review", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("Failed");
      setStatus("success");
    } catch {
      setStatus("error");
    }
  };

  if (status === "success") {
    return (
      <div className="pt-20 min-h-screen bg-gradient-to-b from-cream-100 to-cream-50 flex items-center justify-center px-4">
        <div className="text-center max-w-sm">
          <h2 className="font-display text-3xl text-[#2f502a] mb-3">
            Thank You!
          </h2>
          <p className="text-gray-500 text-sm leading-relaxed">
            Your review has been submitted. 
            <br/>
            We truly appreciate your feedback!
          </p>
        </div>
      </div>
    );
  }

  return (
    
    <div className="pt-36 min-h-screen bg-gradient-to-b from-cream-100 to-cream-50 px-4 py-16">
      <div className="max-w-lg mx-auto">

        <div className="text-center mb-10">
          <p className="font-handwrite text-[#6f9d68] text-xl mb-2">
            Feedback?
          </p>
          <h1 className="font-display text-4xl text-[#2f502a] mb-3">
            Leave a Review
          </h1>
          <p className="text-gray-500 text-sm leading-relaxed">
            We would love to hear what you thought of your macarons!
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-2xl border border-[#9cbd94] p-8 space-y-6"
        >
          {/* Name */}
          <div>
            <label className="block text-sm font-semibold text-[#2f502a] mb-1">
              Name <span className="text-red-400">*</span>
            </label>
            <input
              type="text"
              name="name"
              required
              value={form.name}
              onChange={handleChange}
              placeholder="Your name"
              className="w-full border border-[#9cbd94] rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#6f9d68] bg-white"
            />
          </div>

          {/* Star Rating */}
          <div>
            <label className="block text-sm font-semibold text-[#2f502a] mb-2">
              Rating <span className="text-red-400">*</span>
            </label>
            <div className="flex gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button"
                  onClick={() => setForm((prev) => ({ ...prev, rating: star }))}
                  onMouseEnter={() => setHovered(star)}
                  onMouseLeave={() => setHovered(0)}
                  className="focus:outline-none"
                >
                  <Star
                    size={32}
                    className={`transition-colors ${
                      star <= (hovered || form.rating)
                        ? "text-amber-400 fill-amber-400"
                        : "text-gray-300"
                    }`}
                  />
                </button>
              ))}
            </div>
            {form.rating === 0 && status === "error" && (
              <p className="text-xs text-red-400 mt-1">Please select a rating.</p>
            )}
          </div>

          {/* Comment */}
          <div>
            <label className="block text-sm font-semibold text-[#2f502a] mb-1">
              Your Review <span className="text-red-400">*</span>
            </label>
            <textarea
              name="comment"
              required
              value={form.comment}
              onChange={handleChange}
              rows={4}
              placeholder="Tell us about your experience!"
              className="w-full border border-[#9cbd94] rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#6f9d68] bg-white resize-none"
            />
          </div>

          {status === "error" && (
            <p className="text-red-500 text-sm text-center">
              Something went wrong. Please try again or email us at
              hello@stewartsweetshells.com.
            </p>
          )}

          <button
            type="submit"
            disabled={status === "loading" || form.rating === 0}
            className="w-full bg-[#2f502a] text-white py-3 rounded-full font-semibold text-sm hover:bg-[#6f9d68] transition-colors disabled:opacity-60"
          >
            {status === "loading" ? "Submitting..." : "Submit Review"}
          </button>
        </form>

      </div>
    </div>
  );
}